<template>
  <div>
    <!--Add new video dialog-->
    <v-dialog v-model="newVideoDialog" :retain-focus="false" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="form_title">Paste vido link</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model.trim="editedItem.videoUrl"
            label="Resource URL"
            :rules="urlRules"
            color="light-blue darken-4"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" outlined @click="setVideoUrl">Add</v-btn>
          <v-btn color="error" outlined @click="closeVideoDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Loading dialog-->
    <v-dialog
      v-model="loadingDialog"
      :retain-focus="false"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="light-blue darken-3" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title>
        <span class="form_title">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="delimiter_text">External Resources</h3>
            </v-flex>
            <v-flex xs12>
              <v-btn
                block
                dark
                @click="newVideoDialog = !newVideoDialog"
                color="light-blue darken-4"
              >
                Add new video
              </v-btn>
              <v-responsive v-if="videoLink && videoLink !== ''" class="mt-4">
                <iframe
                  width="100%"
                  height="250"
                  :src="videoLink"
                  frameborder="0"
                  loading="lazy"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-responsive>
            </v-flex>
            <v-flex xs12>
              <h3 class="delimiter_text">General Info</h3>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model.trim="editedItem.drillName"
                label="Drill Name"
                :counter="50"
                required
                outlined
                color="light-blue darken-4"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                class="hidden-sm-only"
                v-model.trim="editedItem.drillPurpose"
                label="Drill Purpose"
                outlined
                color="light-blue darken-4"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                class="hidden-sm-only"
                v-model.trim="editedItem.drillDesc"
                label="Drill Desc"
                required
                outlined
                color="light-blue darken-4"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <h3 class="delimiter_text">Classification</h3>
            </v-flex>

            <v-flex xs12>
              <v-select
                v-model="editedItem.status"
                :items="['Public', 'Private']"
                label="Status"
                required
                outlined
                color="light-blue darken-4"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :outlined="true"
                label="Equipment"
                catName="EQUIPMENT"
                v-model="editedItem.equipment"
                :multiList="true"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :outlined="true"
                label="Sport type"
                catName="SPORT_TYPE"
                v-model="editedItem.sportType"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :outlined="true"
                label="Facility"
                catName="FACILITY"
                v-model="editedItem.facility"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :outlined="true"
                label="Tags"
                catName="STROKE|TAGS_DRILL"
                v-model="editedItem.tag"
                :multiList="true"
              />
            </v-flex>
            <v-flex class="mt-4">
              <complexityLevelsCheckboxes v-model="editedItem.level" />
            </v-flex>
            <v-flex xs12>
              <h3 class="delimiter_text">Share with</h3>
            </v-flex>
            <v-flex>
              <socialSharing
                :drillName="this.editedItem.drillName"
                :drillDesc="this.editedItem.drillDesc"
                :tags="this.editedItem.tag"
                :videoUrl="this.editedItem.videoUrl"
                :sportType="this.editedItem.sportType"
              />
            </v-flex>
            <!-- <v-flex xs12 sm6 md4> -->
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="secondary" text @click="closeDrill">Close</v-btn> -->
        <!-- <v-btn v-if="user" color="secondary" text @click="actionName"
                >Save</v-btn
              > -->
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import catValueDropDown from "../shared/cat_val_dropdown.vue";
import complexityLevelsCheckboxes from "../shared/complexity_levels_checkboxes.vue";
import socialSharing from "../shared/social_sharing.vue";
import {
  youtubeUrlParser,
  sportTypes,
  validationRules
} from "../../constants/global";
export default {
  components: {
    catValueDropDown,
    complexityLevelsCheckboxes,
    socialSharing
  },
  props: {
    parentEditedItem: {
      type: Object,
      default: {
        drillId: "",
        drillName: "",
        drillDesc: "",
        drillPurpose: "",
        videoUrl: "",
        equipment: "",
        sportType: sportTypes,
        facility: "",
        status: "",
        tag: "",
        tab: "",
        level: "",
        "user.userId": "",
        "user.userName": ""
      }
    }
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function() {
      return {
        inner: this.parentEditedItem.drillName
      };
    },
    meta: function() {
      return [
        {
          property: "og:description",
          content: this.parentEditedItem.drillDesc
        },
        { property: "og:image:alt", content: this.parentEditedItem.drillName },
        {
          property: "og:title",
          content:
            this.parentEditedItem.drillName +
            " #" +
            this.parentEditedItem.sportType +
            " #" +
            this.parentEditedItem.tag
        },
        { property: "og:type", content: "video.movie" },
        {
          property: "og:image",
          content:
            "https://img.youtube.com/vi/" + this.videoId + "/maxresdefault.jpg"
        },
        {
          property: "og:url",
          content: "https://portal.sportecos.com" + this.$route.fullPath
        },
        { property: "og:video", content: this.parentEditedItem.videoUrl },
        { property: "og:video:type", content: "video/mp4" },
        { property: "og:video:width", content: "640" },
        { property: "og:video:height", content: "385" }
      ];
    }
  },
  data() {
    return {
      newVideoDialog: false,
      loadingDialog: false,
      editedItem: this.parentEditedItem.node,
      dialog: false,
      formTitle: "",
      videoLink: "",
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length <= 50) || "Name must be less than 10 characters"
      ],
      requiredRule: [v => !!v || "Value is required"],
      isFormValid: true,
      urlRules: [
        v => /^(http|https):\/\/[^ "]+$/.test(v) || "URL must be valid"
      ],
      // ! Remove it
      levels: ["Begginer", "Junior", "Advanced", "Unleveled"],
      levels_selected: ["Begginer", "Junior", "Advanced", "Unleveled"]
    };
  },
  computed: {
    ...mapGetters(["loading", "user", "categoryList", "categoryValue"])
  },
  created: function() {
    console.log(this.editedItem);
    this.setVideoUrl();
  },
  methods: {
    closeDrill() {
      this.dialog = false;
      this.parentEditedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.closeVideoDialog();
    },
    setVideoUrl() {
      const result = youtubeUrlParser(String(this.editedItem.videoUrl));
      this.videoLink = `https://youtube.com/embed/${result}`;
      this.newVideoDialog = false;
    },
    closeVideoDialog() {
      this.newVideoDialog = false;
      this.editedItem.videoUrl = "";
      this.videoLink = "";
    }
  }
};
</script>
